import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const QueryFiltersDialog = ({
  open,
  onClose,
  onConfirm,
  onClearAll,
  showPlayersLabel,
  showPlayersDisabled,
  isExecuting,
  children,
}) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      fullScreen={fullScreen}
      PaperProps={{ sx: { borderRadius: fullScreen ? 0 : 3 } }}
    >
      <DialogTitle sx={{ textAlign: "center", fontWeight: 800, position: "relative" }}>
        Filters
        <IconButton
          aria-label="Close filters"
          onClick={onClose}
          sx={{ position: "absolute", right: 12, top: 10 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>{children}</DialogContent>

      <DialogActions
        sx={{
          position: "sticky",
          bottom: 0,
          bgcolor: "background.paper",
          borderTop: "1px solid",
          borderColor: "divider",
          justifyContent: "space-between",
          px: 3,
          py: 2,
          zIndex: 1,
        }}
      >
        <Button onClick={onClearAll}>Clear all</Button>
        <Button
          variant="contained"
          onClick={onConfirm}
          disabled={showPlayersDisabled || isExecuting}
        >
          {showPlayersLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default QueryFiltersDialog;
